import { ValueLabel } from '../../models';

export enum PeriodType {
  Permanent,
  DateRange,
}

export enum CalculationPeriod {
  Daily,
  Weekly,
  Monthly,
}

export const CalculationPeriodOptions: ValueLabel[] = [
  { value: 0, label: 'Daily' },
  { value: 1, label: 'Weekly' },
  { value: 2, label: 'Monthly' },
];

export interface EditCampaign {
  name: string;
  partnerId: number;
  periodType: PeriodType;
  startDate: Date | null;
  endDate: Date | null;
  calculationPeriod: CalculationPeriod;
  clients: number[];
}

interface EditCampaignClient {
  clientLogin: number;
  currentCampaignName: string;
  isSelected: boolean;
  name: string;
}

export interface Campaign {
  id: number;
  name: string;
  partnerId: number;
  periodType: string;
  startDate: Date;
  endDate: Date;
  calculationPeriod: string;
  clients: number[];
  approvalType: string;
  isDefault: boolean;
  campaignClients: EditCampaignClient[];
}

export interface CampaignRule {
  id: number;
  maxVolume: number;
  minVolume: number;
  name: string;
  percentage: number;
  volumeType: string;
  partnerships: PartnershipRule[];
  accountTypes: AccountType[];
}

export interface EditCampaignRule {
  cashbackCampaignId: number;
  name: string;
  percentage: number;
  partnerships: number[];
  accountTypes: number[];
  minVolume: number | null;
  maxVolume: number | null;
  volumeType: string;
}

export interface CampaignClient {
  currentCampaignName: string;
  id: number;
  name: string;
}

export interface CampaignRuleView {
  id: number;
  priority: number;
  name: string;
  partnerships: string[];
  accountTypes: string[];
  minVolume: number;
  maxVolume: number | null;
  volumeType: string;
  percentage: number;
  isDefault: boolean;
}

export interface CampaignView {
  id: number;
  name: string;
  periodType: string;
  startDate: Date | null;
  endDate: Date | null;
  totalClients: number;
  totalRules: number;
  isDefault: boolean;
  status: string;
  calculationPeriod: string;
  rules: CampaignRuleView[];
}

export interface PartnershipRule {
  partnershipId: number;
  partnershipCode: string;
}

export interface AccountType {
  accountTypeId: number;
  accountTypeName: string;
}

export interface CampaignRuleSetup {
  partnerships: PartnershipRule[];
  accountTypes: AccountType[];
}

export interface RulesModel {
  ruleId: number;
  priority: number;
}

export interface UpdatePriorityRule {
  ruleModels: RulesModel[];
}

export enum PaymentStatus {
  Pending,
  Paid,
  Rejected,
  Failed,
  InProgress,
  Mixed,
}

interface PaymentId {
  timestamp: number;
  creationTime: Date;
}

export interface Payments {
  paymentId: PaymentId;
  campaignName: string;
  clientCount: number;
  commissionAmmount: number;
  cashbackAmount: number;
  status: string;
  periodStart: Date;
  periodEnd: Date;
  isSuccess: boolean;
}
